import TooltipPlain, { Props as TooltipPlainProps } from '../TooltipPlain';
import TooltipRich, { Props as TooltipRichProps } from '../TooltipRich';

export type Props =
  | ({ variant?: 'plain' } & TooltipPlainProps)
  | ({ variant: 'rich' } & TooltipRichProps);

const Tooltip = ({ variant = 'plain', ...otherProps }: Props) => {
  if (variant === 'rich') {
    return <TooltipRich {...(otherProps as TooltipRichProps)} />;
  }
  return <TooltipPlain {...(otherProps as TooltipPlainProps)} />;
};

export default Tooltip;
